import * as React from 'react';
import { useIntl } from 'react-intl';

import groupBy from 'lodash/groupBy';
import { StoreApi } from 'zustand';

import { FilterItemCheckbox, SearchInput } from '@notino/react-styleguide';
import { normalizeStringAndLowerCase } from '@notino/react-web-utils';
import { WishlistFiltrationGroupType } from '@notino/shared/definitions/types';

import messages from '../messages';

import {
  BrandsMultiSelectWrapper,
  DrawerSearchWrapper,
  Letter,
} from './styled';
import { useMultiSelectList } from './useMultiSelectList';

type Props = {
  groupType: WishlistFiltrationGroupType;
  store: StoreApi<{
    selectedItems: Array<{
      name: string;
      navigationValue: number;
    }>;
  }>;
};

export const BrandsMultiSelectList = ({ groupType, store }: Props) => {
  const { formatMessage } = useIntl();
  const [search, setSearch] = React.useState('');
  const { filter, isChecked, onChange } = useMultiSelectList({
    groupType,
    store,
  });

  const items = (filter?.items ?? []).filter((item) =>
    normalizeStringAndLowerCase(item.name).includes(
      normalizeStringAndLowerCase(search)
    )
  );

  const groups = search
    ? { '': items }
    : groupBy(items, (item) =>
        Number.isInteger(Number(item.name[0]))
          ? '#'
          : item.name[0].toUpperCase()
      );

  return (
    <BrandsMultiSelectWrapper>
      <DrawerSearchWrapper>
        <SearchInput
          value={search}
          onChange={setSearch}
          searchIconRight={true}
          placeholder={formatMessage(messages.brandsSearchPlaceholder)}
        />
      </DrawerSearchWrapper>

      {Object.keys(groups).map((letter, index) => (
        <React.Fragment key={letter}>
          <Letter isFirst={index === 0}>{letter}</Letter>
          {groups[letter].map((item) => (
            <FilterItemCheckbox
              key={item.navigationValue}
              count={item.count}
              isChecked={isChecked(item)}
              onChange={(checked) => onChange(!checked, item)} // why the fuk is "checked" reversed?
            >
              {item.name}
            </FilterItemCheckbox>
          ))}
        </React.Fragment>
      ))}
    </BrandsMultiSelectWrapper>
  );
};
